module.exports = __webpack_public_path__ + "static/media/kitchen-trousers.6f2aed41.jpg";